exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Form__Buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n", ""]);

// exports
